import { createSlice, combineReducers } from '@reduxjs/toolkit'
import { PasswordRulesServerData } from '@lk/api'

import { LoadUserConfigPayload, loadUserConfigs, loadPasswordRules } from './userConfig.actions'
import { ActionPayload } from '../index.d'

export interface UserConfigState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  user: any
  system: any
}

const configInitialState: UserConfigState = {
  status: 'idle',
  error: null,
  user: null,
  system: null,
}

export const configReducer = createSlice({
  name: 'config',
  initialState: configInitialState,
  reducers: {},
  extraReducers: {
    [loadUserConfigs.pending.toString()]: (state) => {
      state.status = 'loading'
      state.error = null
    },
    [loadUserConfigs.fulfilled.toString()]: (state, action: ActionPayload<LoadUserConfigPayload>) => {
      state.status = 'loaded'
      state.user = action.payload.user
      state.system = action.payload.system
    },
    [loadUserConfigs.rejected.toString()]: (state, action: ActionPayload<string>) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer

export type PasswordRulesState = Array<{
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error?: string | null
  data?: Record<number | string, PasswordRulesServerData>
}>

const passwordRulesInitialState: PasswordRulesState = []

export const passwordRulesReducer = createSlice({
  name: 'passwordRules',
  initialState: passwordRulesInitialState,
  reducers: {},
  extraReducers: {
    [loadPasswordRules.pending.toString()]: (state, action) => {
      const { userID } = action.meta.arg

      state[userID] = {
        status: 'loading',
      }
    },
    [loadPasswordRules.fulfilled.toString()]: (state, action) => {
      const { userID } = action.meta.arg

      state[userID] = {
        status: 'loaded',
        data: action.payload,
      }
    },
    [loadPasswordRules.rejected.toString()]: (state, action) => {
      const { userID } = action.meta.arg

      state[userID] = {
        status: 'failed',
        error: action.payload,
      }
    },
  },
}).reducer

export const userConfigReducer = combineReducers({
  config: configReducer,
  passwordRules: passwordRulesReducer,
})
